var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93477 5.30977L1.55977 9.68478C1.51913 9.72542 1.47087 9.75767 1.41776 9.77966C1.36465 9.80166 1.30773 9.81299 1.25024 9.81299C1.19276 9.81299 1.13584 9.80166 1.08273 9.77966C1.02962 9.75767 0.98136 9.72542 0.940712 9.68478C0.900064 9.64413 0.86782 9.59587 0.845821 9.54276C0.823822 9.48965 0.8125 9.43273 0.8125 9.37524C0.8125 9.31776 0.823822 9.26084 0.845821 9.20773C0.86782 9.15462 0.900064 9.10636 0.940712 9.06571L5.00673 5.00024L0.940712 0.934775C0.858619 0.852682 0.8125 0.74134 0.8125 0.625243C0.8125 0.509147 0.858619 0.397805 0.940712 0.315712C1.0228 0.233619 1.13415 0.1875 1.25024 0.1875C1.36634 0.1875 1.47768 0.233619 1.55977 0.315712L5.93477 4.69071C5.97545 4.73134 6.00772 4.7796 6.02974 4.83271C6.05175 4.88582 6.06309 4.94275 6.06309 5.00024C6.06309 5.05774 6.05175 5.11467 6.02974 5.16778C6.00772 5.22089 5.97545 5.26914 5.93477 5.30977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.ff02511e0f8f060a6ea1a3c410e43647.svg";
export { ForwardRef as ReactComponent };